import { createTranslations } from '@momentum/i18n';
import { onboardingEnTranslations } from './onboarding.en';

export const onboardingHeTranslations = createTranslations(
  onboardingEnTranslations,
  {
    title: 'ברוכים הבאים ל-Intera',
    description: 'בואו נתחיל להגדיר אותך. אנא מלא את הטופס למטה.',
    firstName: 'שם פרטי',
    lastName: 'שם משפחה',
    imageUrl: 'כתובת תמונה',
    submit: 'שלח',
    submitting: 'שולח...',
    onboardingFailed: 'התהליך נכשל',
    onboardingWelcome: 'לחץ עליי בשביל להתחיל',
    selectTeam: 'בחר את הצוות שלך',
    selectTeamDescription: 'בחר את הצוות אליו אתה מצטרף',
    noTeamsAvailable: 'אין צוותים זמינים',
    continue: 'המשך',
    loadingTeams: 'טוען צוותים...',
    searchPlaceholder: 'חפש צוותים לפי שם או תיאור...',
    noSearchResults: 'לא נמצאו צוותים התואמים לחיפוש שלך',
    completeWithoutTeam: 'השלם תהליך ללא צוות',
    preparing: 'מכין את סביבת העבודה שלך…',
    admin: {
      step: {
        integrations: 'חיבור',
        processing: 'עיבוד',
      },
      integrations: {
        stepBadge: 'אינטגרציות',
        heading: 'בואו נחבר את הכלים של החברה',
        subheading:
          'Intera קוראת את הכלים שלכם כדי ללמוד איך החברה באמת פועלת. ככל שתחברו יותר, התובנות יהיו חדות יותר.',
        connectedCount_zero: 'עדיין לא חוברו כלים',
        connectedCount_one: 'כלי {{count}} מחובר',
        connectedCount_other: '{{count}} כלים מחוברים',
        connect: 'חיבור',
        connecting: 'מתחבר…',
        connected: 'מחובר',
        comingSoon: 'בקרוב',
        comingSoonHint: 'יהיה זמין בקרוב',
        continue: 'המשך',
        softGateHint: 'חברו לפחות כלי אחד כדי להמשיך.',
        nudgeMore: 'תוכלו לחבר עוד כלים מאוחר יותר — אפשר להמשיך מתי שתרצו.',
        providers: {
          sharepoint: {
            name: 'Microsoft SharePoint',
            description: 'אינדוקס של מסמכים, PRD-ים ומאגרי ידע.',
          },
          dynamicsCrm: {
            name: 'Microsoft Dynamics CRM',
            description: 'קריאה של לקוחות, הזדמנויות ואנשי קשר.',
          },
          jira: {
            name: 'Jira',
            description: 'קריאה של איסיוז, פרויקטים ותגובות.',
          },
          confluence: {
            name: 'Confluence',
            description: 'קריאה של דפים ומרחבי עבודה.',
          },
          slack: {
            name: 'Slack',
            description: 'ערוצים, שרשורים והודעות אישיות (קריאה בלבד).',
          },
          salesforce: {
            name: 'Salesforce',
            description: 'לקוחות, הזדמנויות ופייפליין.',
          },
          microsoftTeams: {
            name: 'Microsoft Teams',
            description: 'ערוצים, שיחות וצ׳אטים של צוות.',
          },
          googleDrive: {
            name: 'Google Drive',
            description: 'קבצים, מסמכים ותיקיות משותפות.',
          },
          notion: {
            name: 'Notion',
            description: 'דפים, מסדי נתונים ו-wikis.',
          },
          github: {
            name: 'GitHub',
            description: 'מאגרים, בקשות משיכה ואיסיוז.',
          },
          hubspot: {
            name: 'HubSpot',
            description: 'אנשי קשר, עסקאות ופייפליין.',
          },
          asana: {
            name: 'Asana',
            description: 'פרויקטים, משימות וצירי זמן.',
          },
          linear: {
            name: 'Linear',
            description: 'איסיוז, פרויקטים וסיקלים.',
          },
          zoom: {
            name: 'Zoom',
            description: 'פגישות והקלטות.',
          },
          zendesk: {
            name: 'Zendesk',
            description: 'כרטיסים ושרשורי לקוחות.',
          },
          monday: {
            name: 'monday.com',
            description: 'לוחות, משימות ותהליכים.',
          },
        },
      },
      processing: {
        headline: 'אתם יכולים לסגור את החלון. Intera עכשיו עושה את החלק שלה.',
        subheading: 'אנחנו נציג לכם את מה שנמצא בכניסה הבאה שלכם.',
        manageIntegrations: 'חבר עוד אינטגרציות',
      },
    },
    holding: {
      heading: 'רגע קט. הצוות שלך עדיין בהקמה.',
      subheading:
        'הצוות שלך עדיין לא חיבר את הכלים שלו. נעדכן אותך כשיהיה משהו להראות.',
      continue: 'המשך ללוח הבקרה',
    },

    // Get-started gate — shown before a page that requires a completed account
    getStarted: {
      title: 'ברוכים הבאים ל-INTERA-AI',
      cta: 'התחילו להשתמש ב-Intera',
      starting: 'מגדירים את החשבון שלך…',
      failed: 'לא הצלחנו לסיים את הגדרת החשבון שלך.',
    },

    // Insights flow
    insights: {
      welcome: {
        eyebrow: 'המבט הראשון שלך',
        title: 'כבר קראנו את העולם שלך.',
        subtitle: 'הנה מה שבולט.',
        cta: 'תראו לי',
      },
      progress: {
        step: (current: number, total: number) => `${current} מתוך ${total}`,
      },
      pastLesson: {
        eyebrow: 'כבר קרה',
        title: ({ cost }: { cost: string }) =>
          `אותו פער עלה לכם ${cost} ברבעון שעבר.`,
        subtitle:
          'התכנית אמרה דבר אחד. ההשקה בפועל אמרה משהו אחר. זה הלקח, כדי שלא יחזור.',
        planLabel: 'תכנית',
        actualLabel: 'בפועל',
        lateBadge: ({ cost }: { cost: string }) => `${cost} באיחור`,
        rootCauseLabel: 'שורש הבעיה:',
      },
      misalignment: {
        eyebrow: 'זוהתה אי-התאמה',
        title: 'שני מקורות מספרים סיפורים שונים.',
        sourcesLabel: 'מקורות סותרים',
        contradictionLabel: 'סותר ישירות',
        dismiss: 'התעלם',
        snooze: 'דחה',
      },
      procedureSlipped: {
        eyebrow: 'נוהל לא נשמר',
        title: 'למדנו איך החברה שלך עובדת, ואיתרנו פספוס.',
        ruleLabel: 'לקח מוסק',
        missLabel: 'חריגה פעילה',
        sourcesLabel: 'איפה לאמת',
        dismiss: 'התעלם',
        snooze: 'דחה',
      },
      done: {
        eyebrow: 'הכל מוכן',
        title: 'Intera עובדת ברקע מעכשיו.',
        subtitle: 'תובנות חדשות יופיעו לאורך עבודת הצוות שלך.',
        cta: 'קח אותי ללוח הבקרה',
      },
      coldStart: {
        eyebrow: 'אנחנו עדיין לומדים',
        title: 'Intera קוראת את העולם שלך כרגע.',
        subtitle:
          'אין לנו עדיין מספיק נתונים להציג תובנות. חבר עוד כלים כדי לזרז את התהליך.',
        processedHeading: 'מה עיבדנו עד עכשיו',
        counts: {
          sharepointFiles: (count: number) => `${count} קבצי SharePoint נסרקו`,
          jiraIssues: (count: number) => `${count} משימות Jira נקראו`,
          confluencePages: (count: number) => `${count} דפי Confluence נסרקו`,
          crmAccounts: (count: number) => `${count} לקוחות CRM קושרו`,
        },
        connectCta: 'חבר אינטגרציות נוספות',
        finishCta: 'קח אותי ללוח הבקרה',
      },
      feedback: {
        prompt: 'התובנה הזו עזרה לך?',
        like: 'עזרה',
        dislike: 'לא עזרה',
        continueHint: 'בחר/י כדי להמשיך',
      },
      sourceProvider: {
        slack: 'Slack',
        jira: 'Jira',
        confluence: 'Confluence',
        'dynamics-crm': 'Dynamics CRM',
        sharepoint: 'SharePoint',
      },
      openSource: 'פתח',
      completeFailed: 'לא הצלחנו לסיים את הגדרת החשבון שלך.',
    },
  }
);
